import { render, staticRenderFns } from "./FleetAlerts.vue?vue&type=template&id=5222a5ac&scoped=true"
import script from "./FleetAlerts.vue?vue&type=script&lang=js"
export * from "./FleetAlerts.vue?vue&type=script&lang=js"
import style0 from "./FleetAlerts.vue?vue&type=style&index=0&id=5222a5ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5222a5ac",
  null
  
)

export default component.exports